// @ts-nocheck
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { ReservedMembersOfWeekItem, ScheduleCoach } from '#types/schedule';
import { CalendarPeriodic, TimelineColumns } from '../types';
import { getIdByDate, getWeekData } from '../utils';

interface Params {
  data?: ScheduleCoach[] | ReservedMembersOfWeekItem[];
  activeDate?: dayjs.Dayjs;
  calendarPeriodic: CalendarPeriodic;
}

/** 주간 데이터를 기준으로 colums를 추가 */
export default function useDateBasedColumns({
  data,
  activeDate,
  calendarPeriodic
}: Params) {
  const [columns, setColumns] = useState<TimelineColumns[]>([]);

  useEffect(() => {
    if (!data) {
      return;
    }

    const weekData = getWeekData(activeDate);

    if (calendarPeriodic === 'WEEKLY') {
      const columnTemplate: TimelineColumns[] = weekData.map(date => {
        const columnId = getIdByDate(date, false);
        const reservedData = data.find(
          item => getIdByDate(item.date, false) === columnId
        );

        return {
          id: getIdByDate(date, false),
          date,
          data: reservedData?.reservedMembers ?? []
        };
      });

      setColumns(columnTemplate);
    } else {
      const newState = [];

      newState.push({
        id: getIdByDate(activeDate, false),
        date: dayjs(activeDate),
        data: data[0]?.reservedMembers ?? [],
        displayText() {
          return null;
        }
      });

      setColumns(newState);
    }
  }, [data, calendarPeriodic]);

  return columns;
}
